// frontend/src/components/common/SecurityInformation.jsx
import React from "react";

const SecurityInformation = ({ className = "" }) => {
  return (
    <div className={`mt-4 ${className}`}>
      <div className="d-flex align-items-center mb-3">
        <i
          className="bi bi-shield-check me-2 text-muted"
          aria-hidden="true"
        ></i>
        <span className="fw-semibold text-muted">Security Information</span>
      </div>

      <ul className="list-unstyled mb-0 text-muted">
        <li className="mb-1">
          • All data is encrypted using AES-256 encryption
        </li>
        <li className="mb-1">
          • Access logs are maintained for audit purposes
        </li>
        <li className="mb-1">
          • Electronic signatures are legally binding under the E-Sign Act
        </li>
        <li className="mb-0">
          • Reports are stored in HIPAA-compliant cloud storage
        </li>
      </ul>
    </div>
  );
};

export default SecurityInformation;
